<template>
  <v-container
    fluid
    fill-height
    class="loginContainer"
    :style="backgroundColor()"
  >
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 lg4 style="max-width: 420px;" class="mx-auto">
        <v-card tile flat color="transparent">
          <v-toolbar dense flat card dark color="theme_primary">
            <v-toolbar-side-icon>
              <v-img :src="image_src" aspect-ratio="1" width="32"></v-img>
            </v-toolbar-side-icon>
            <v-toolbar-title>CTC Platform</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert v-if="errors !== ''" :value="true">{{ errors }}</v-alert>

            <v-form v-model="valid">
              <v-text-field
                prepend-icon="mail"
                v-model="login"
                name="login"
                label="Login"
                type="text"
                persistent-hint
                dark
                solo
                flat
                background-color="rgba(0,0,0,0.2)"
              ></v-text-field>
              <v-text-field
                @keyup.enter="userLogin"
                v-model="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                persistent-hint
                dark
                solo
                flat
                background-color="rgba(0,0,0,0.2)"
              ></v-text-field>
              <v-text-field
                @keyup.enter="userLogin"
                v-model="code_token"
                prepend-icon="vpn_key"
                name="code_token"
                label="2FA (if enabled)"
                type="code_token"
                persistent-hint
                dark
                solo
                flat
                browser-autocomplete="off"
                background-color="rgba(0,0,0,0.2)"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              round
              color="theme_primary white--text"
              @click="userLogin"
              >Login</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-footer
          xs12
          lg12
          class="pa-3 white--text"
          color="theme_primary_darken1"
        >
          <v-spacer></v-spacer>
          <div class="caption">
            &copy; {{ new Date().getFullYear() }} Commodities Trading
            Corporation Ltd.
          </div>
          <v-spacer></v-spacer>
        </v-footer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import USER_LOGIN from "../graphql/users/login.gql";
export default {
  name: "login",
  data() {
    return {
      image_src: require("../assets/logo.png"),
      valid: false,
      login: "",
      password: "",
      errors: "",
    };
  },
  methods: {
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },
    backgroundColor() {
      var c1 = this.$vuetify.theme.theme_primary_darken1;
      return `background: linear-gradient(rgba(${this.hexToRgb(c1).r},${
        this.hexToRgb(c1).g
      },${this.hexToRgb(c1).b}, 0.98),rgba(${this.hexToRgb(c1).r},${
        this.hexToRgb(c1).g
      },${
        this.hexToRgb(c1).b
      }, 0.98)), url(../public_images/background_cover.jpg) no-repeat center center fixed !important; -webkit-background-size: cover !important;  -moz-background-size: cover !important;  -o-background-size: cover !important;  background-size: cover !important;;`;
    },
    userLogin() {
      const variables = {
        email: this.login,
        password: this.password,
        code_token: this.code_token,
      };
      this.$apollo
        .mutate({
          mutation: USER_LOGIN,
          variables: variables,
          context: { login: true },
        })
        .then(({ data }) => {
          this.$store.commit("commonStore/setLoggedIn", true);
          this.$router.go();
        })
        .catch((error) => {
          this.$store.dispatch(
            "notificationStore/error",
            error.networkError.result.errors[0].message
          );
        });
    },
  },
};
</script>
